import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';

// HDRI paths
const hdrUrls = [
    { id: 'hdr1', name: 'Lawn', url: new URL('../hdr/Lawn.hdr', import.meta.url) },
    { id: 'hdr2', name: 'Entrance', url: new URL('../hdr/Entrance.hdr', import.meta.url) },
    { id: 'hdr3', name: 'Lobby1', url: new URL('../hdr/Lobby1.hdr', import.meta.url) },
    { id: 'hdr4', name: 'Lobby2', url: new URL('../hdr/Lobby2.hdr', import.meta.url) },
    { id: 'hdr5', name: 'Right Lobby', url: new URL('../hdr/RightLobby.hdr', import.meta.url) },
    { id: 'hdr6', name: 'Left Lobby', url: new URL('../hdr/LeftLobby.hdr', import.meta.url) },
    { id: 'hdr7', name: 'Left Lobby 1', url: new URL('../hdr/LeftLobby1.hdr', import.meta.url) },
];

// Scene setup
const renderer = new THREE.WebGLRenderer();
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.toneMapping = THREE.EquirectangularRefractionMapping;
renderer.toneMappingExposure = 0.9;
document.body.appendChild(renderer.domElement);

const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.set(-1, 20, 45);

const orbit = new OrbitControls(camera, renderer.domElement);
orbit.update();

const preloadedTextures = {}; // Store preloaded HDR textures

// Preload all HDRIs
async function preloadHDRIs() {
    const loader = new RGBELoader();
    const promises = hdrUrls.map((hdr) => {
        return new Promise((resolve) => {
            loader.load(hdr.url.href, (texture) => {
                texture.mapping = THREE.EquirectangularRefractionMapping;
                preloadedTextures[hdr.id] = texture;
                resolve();
            });
        });
    });
    await Promise.all(promises);
    console.log('All HDRIs preloaded.');
}

// Load preloaded HDRI into the scene
function loadHDRI(hdrId) {
    if (scene.background === preloadedTextures[hdrId]) return; // Avoid redundant re-renders
    const texture = preloadedTextures[hdrId];
    scene.background = texture;
    scene.environment = texture;
}

// Dynamically populate dropdown
function populateDropdown() {
    const dropdown = document.getElementById('hdrDropdown');
    hdrUrls.forEach((hdr) => {
        const option = document.createElement('option');
        option.value = hdr.id;
        option.textContent = hdr.name;
        dropdown.appendChild(option);
    });

    // Event listener for dropdown change
    dropdown.addEventListener('change', (event) => {
        const selectedHDR = event.target.value;
        loadHDRI(selectedHDR);
    });
}

// Initialization
async function init() {
    const loadingDiv = document.getElementById('loading');
    loadingDiv.style.display = 'block'; // Show loading indicator
    await preloadHDRIs();
    loadingDiv.style.display = 'none'; // Hide loading indicator

    populateDropdown(); // Populate dropdown after preload

    // Set default HDRI (Lawn)
    loadHDRI('hdr1');
    console.log('Default HDRI (Lawn) loaded.');
}

init();

function animate() {
    renderer.render(scene, camera);
}

renderer.setAnimationLoop(animate);
